module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099LB4VB2.6d345de8.jpg";